@if (_currentTask) {
    <div style="text-align: center">
        <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="4" animationDuration="1.5s"></p-progressSpinner>
        <div class="gray-text centered-text mt-2 mb-2">Feature under construction</div>
    </div>
} @else if (showLoading) {
    <div style="text-align: center">
        <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="4" animationDuration="1.5s"></p-progressSpinner>
        <div class="gray-text centered-text mt-2 mb-2">Task is loading, please wait.</div>
    </div>
} @else {
    <p class="gray-text centered-text mt-4 mb-4">
        No task selected, please select a task first!<br /><span class="pi pi-arrow-left"></span>
    </p>
}
